import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";

export async function fetchUserProfile() {
  const { data: { user }, error: authError } = await supabase.auth.getUser();
  if (authError || !user) throw new Error("Not logged in");

  const { data: profile, error: profileError } = await supabase
    .from("profiles")
    .select("team, role, first_name, last_name, email")
    .eq("id", user.id)
    .single();

  if (profileError || !profile) throw new Error("Profile not found");

  return { user, profile };
}

export function useUser() {
  return useQuery({
    queryKey: ["authUser"],
    queryFn: fetchUserProfile,
    retry: false,
  });
}